// C-1: the Control & Admin search box on the pages that are not the Settings page (Data refreshes, Data health, Language, Audit log, ...).
// Settings pages carry the same box inside SettingsPage (their record index + this registry). Pure registry search: label / help words, EN + FR.
// 47231: the box itself is the shared HeaderSearch (the same component SettingsPage renders).
import React, { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useNavLabels from './useNavLabels';
import { usePageHeaderSlot } from './PageHeaderActions';
import { useAuth } from '../context/AuthContext';
import HeaderSearch, { groupByTab } from './HeaderSearch';
import { allControlAdminEntries, foldText, setPendingHit } from '../components/Settings/controlAdminSearch';

export default function ControlAdminSearch() {
  const { t } = useTranslation('common');
  const nav = useNavLabels(), navigate = useNavigate(), { isAdmin, isVisible, isTabVisible } = useAuth();
  const slot = usePageHeaderSlot(true);
  const [q, setQ] = useState('');
  const entries = useMemo(() => { let n = 0; return allControlAdminEntries({ nav, isAdmin, isVisible, isTabVisible }, () => n++); }, [nav, isAdmin, isVisible, isTabVisible]);
  const fq = foldText(q.trim());
  const groups = useMemo(() => groupByTab(fq ? entries.filter(e => e.searchText.includes(fq)).slice(0, 30) : []), [entries, fq]);
  const pick = e => { setPendingHit(e); setQ(''); navigate(e.path); };
  const node = <HeaderSearch value={q} onChange={setQ} onClear={() => setQ('')} onPick={pick} groups={groups} placeholder={t('stgUi.searchSettings')} clearLabel={t('stgUi.clearSearch')}
    emptyText={`${t('stgUi.noResultsFor')}${q}"`} testid="ctl-admin-search" />;
  return slot ? createPortal(node, slot) : null;
}
